import { useContext, useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { EmployeeDto } from "../../../../dtos/catalogs/employee/EmployeeDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import EmployeeDetailSkeleton from "./EmployeeDetailSkeleton";
import EmployeeDetailMain from "./EmployeeDetailMain";
import EmployeeDetailSettlement from "./EmployeeDetailSettlement";
import EmployeeDetailsContract from "./EmployeeDetailsAccrualsDeductions";
import EmployeeDetailsAccrualsDeductions from "./EmployeeDetailsAccrualsDeductions";
import EmployeeDetailContract from "./EmployeeDetailContract";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";

interface IProps {
  model: EmployeeDto | null;
  modelUpdatedEvent: (newModel: EmployeeDto) => void;
}

interface EmployeeModel {
  name?: string;
  companyInsurance?: number;
  companySalary: number;
  divisionId?: string;
  positionId?: string;
  personId?: string;
  companyId?: string;
  hireDate?: Date;
  uniqueCode?: string;
  departureDate?: Date;
  createdDate?: Date;
  dateOfBirth?: Date;
  gender?: number;
  tin?: string;
  lastName?: string;
  firstName?: string;
  vendorCustomerId?: string;
  fromDatePensionFund?: string;
  salaryCurrencyId?: string;
  pensionFundParticipation?: boolean;
  countryId?: string;
  bankAccountId?: string;
  isGroup?: boolean;
  parentId?: string;
  employeeStatus?: number;
  referenceType?: number;
  createdUserId?: string;
  id?: string;
}

export const EmployeeDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<EmployeeModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("companyInsurance", model.companyInsurance);
      setValue("companySalary", model.companySalary);
      setValue("divisionId", model.divisionId);
      setValue("positionId", model.positionId);
      setValue("personId", model.personId);
      setValue("companyId", model.companyId);
      setValue("hireDate", model.hireDate);
      setValue("departureDate", model.departureDate);
      setValue("dateOfBirth", model.dateOfBirth);
      setValue("tin", model.tin);
      setValue("createdDate", model.createdDate);
      setValue("lastName", model.lastName);
      setValue("uniqueCode", model.uniqueCode);
      setValue("firstName", model.firstName);
      setValue("gender", model.gender);
      setValue("vendorCustomerId", model.vendorCustomerId);
      setValue("fromDatePensionFund", model.fromDatePensionFund);
      setValue("salaryCurrencyId", model.salaryCurrencyId);
      setValue("pensionFundParticipation", model.pensionFundParticipation);
      setValue("countryId", model.countryId);
      setValue("bankAccountId", model.bankAccountId);
      setValue("isGroup", model.isGroup);
      setValue("parentId", model.parentId);
      setValue("employeeStatus", model.employeeStatus);
      setValue("referenceType", model.referenceType);
      setValue("createdUserId", model.createdUserId);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: EmployeeModel) => {
    if (action === "save") {
      //@ts-ignore
      const newModel: EmployeeDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      await saveHandler(newModel);
    }
  };

  if (!model) {
    return (
      <>
        <EmployeeDetailSkeleton />
      </>
    );
  }

  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
          <NFTab title={"Settlement History"} />
          <NFTab title={"Accruals/Deductions"} />
          <NFTab title={"Contract"} />
        </NFTabs>

        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <EmployeeDetailMain />
        </NFTabContainer>
        <NFTabContainer index={1} currentIndex={tabIndex}>
          <EmployeeDetailSettlement />
        </NFTabContainer>
        <NFTabContainer index={2} currentIndex={tabIndex}>
          <EmployeeDetailsAccrualsDeductions />
        </NFTabContainer>
        <NFTabContainer index={3} currentIndex={tabIndex}>
          <EmployeeDetailContract />
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
